import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
const _base = "zxStudentLiveLearn/";

// 直播学习最终记录 - 列表
export const studentLiveLearnMyPage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "myPage", {
    data: _params,
    method: "GET",
  });
};
// 直播学习最终记录 - 添加
export const studentLiveLearnAdd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "add", {
    data: _params,
    method: "POST",
  });
};


// WEBPACK FOOTER //
// ./src/fetch/api/studentLiveLearn.js